module.exports = __webpack_public_path__ + "img/Girl_010027.28d0746c.png";